import type { ReactNode } from 'react'

interface PageHeroProps {
  eyebrow?: string
  title: string
  description?: string
  children?: ReactNode
}

/** 二级页面顶部 Hero 横幅 */
export function PageHero({ eyebrow, title, description, children }: PageHeroProps) {
  return (
    <section className="page-hero">
      <div className="page-hero-bg" aria-hidden="true" />
      <div className="container page-hero-inner">
        {eyebrow && <span className="eyebrow reveal">{eyebrow}</span>}
        <h1 className="page-hero-title reveal delay-1">{title}</h1>
        {description && <p className="page-hero-desc reveal delay-2">{description}</p>}
        {children}
      </div>
    </section>
  )
}
